import Vue from 'vue';
import VueRouter from 'vue-router';
import { combinedRoutes } from './modules';
import { checkAuth, checkAuthForEmbed } from '@/biz/base';
import { isEmbed, isWxwork, sessionOrLocal, parseToken } from '@/tools/utils';
// Vue-router 报NavigationDuplicated的可能解决方案
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes: combinedRoutes
});

router.beforeEach((to, from, next) => {
  Vue.prototype.$isEmbed = isEmbed(to.path);
  Vue.prototype.$isWxwork = isWxwork(to.path);

  if (to.meta.auth) {
    if (isEmbed()) {
      checkAuthForEmbed(to, from, next);
    } else {
      checkAuth(to, from, next);
    }
  } else {
    if (to.path.indexOf('/embed/wxwork/login') > -1) {
      let token = sessionOrLocal.get('token', 'localStorage') || '';
      if (token) {
        const tokenJson = parseToken(token);
        if (Date.now() < tokenJson?.exp * 1000) {
          // 已经登录了,并且未超期，自动跳转到列表页
          next('/embed/wxwork/material');
          return;
        }
      }
    }
    next();
  }
});

export default router;
